const locales = [
  {
    locale: "en",
    loadData: import(`@formatjs/intl-relativetimeformat/locale-data/en`),
  },
  {
    locale: "de",
    loadData: import(`@formatjs/intl-relativetimeformat/locale-data/de`),
  },
];

export default locales;
